import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#060607]" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3">
          <img src="/assets/logo.webp" alt="Alpha Peps logo" className="h-9 w-auto" />
          <span className="font-display text-lg font-extrabold tracking-[0.25em] text-white">
            ALPHA<span className="text-[#E8E9EB]">PEPS</span>
          </span>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
          Bio-engineered cellular optimization and scientific longevity. Pharmaceutical-grade research peptides,
          third-party verified.
        </p>
      </div>
      <div>
        <div className="font-mono text-[11px] tracking-[0.25em] text-[#E8E9EB]">NAVIGATE</div>
        <div className="mt-4 flex flex-col gap-3">
          <Link to="/products" data-testid="footer-link-products" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Shop Products</Link>
          <Link to="/benefits" data-testid="footer-link-benefits" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Health Benefits</Link>
          <Link to="/contact" data-testid="footer-link-contact" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Contact & Support</Link>
        </div>
      </div>
      <div>
        <div className="font-mono text-[11px] tracking-[0.25em] text-[#E8E9EB]">CONTACT</div>
        <div className="mt-4 flex flex-col gap-3 text-sm text-slate-400">
          <span className="flex items-center gap-3"><Mail className="h-4 w-4 text-[#6E7683]" /> alphapepsaus@gmail.com</span>
          <span className="flex items-center gap-3"><MapPin className="h-4 w-4 text-[#6E7683]" /> Sydney NSW, Australia</span>
        </div>
      </div>
    </div>
    <div className="border-t border-white/5 px-5 py-6 text-center font-mono text-[10px] tracking-[0.15em] text-slate-600">
      <p data-testid="footer-refund-policy">ALL SALES ARE FINAL ONCE DISPATCHED. ORDERS CANNOT BE REFUNDED AFTER YOUR ORDER HAS BEEN DISPATCHED.</p>
      <p className="mt-2">FOR LABORATORY RESEARCH USE ONLY. NOT FOR HUMAN CONSUMPTION. (C) 2026 ALPHA PEPS. ALL RIGHTS RESERVED.</p>
    </div>
  </footer>
);
